const PercentileItem: string[] = ['p50', 'p75', 'p90', 'p95', 'p99'];
import { State, Call } from './topology.store';
interface Node {
  apdex: number;
  avgResponseTime: number;
  cpm: number;
  id: string;
  isAlarm: boolean;
  name: string;
  numOfServer: number;
  numOfServerAlarm: number;
  numOfServiceAlarm: number;
  sla: number;
  type: string;
}
const mutations = {
	setCallback(state: State, data: any) {
		state.callback = data;
	},
	setMode(state: State, data: string[]) {
		state.detectPoints = data;
		const temp = state.mode ? 'SERVER' : 'CLIENT';
		if (data.indexOf(temp) === -1) {
			state.mode = !state.mode;
		}
	},
	setModeStatus(state: State, data: boolean) {
		state.mode = data;
	},
	setNode(state: State, data: any) {
		state.currentNode = data;
	},
	setLink(state: State, data: any) {
		state.currentLink = data;
	},
	setTopo(state: State, data: any) {
		state.calls = data.calls;
		state.nodes = data.nodes;
	},
	setSelectedCall(state: State, data: any) {
		state.selectedServiceCall = data;
	},
	setTopoRelation(state: State, data: any) {
		state.getResponseTimeTrend = data.getResponseTimeTrend
			? data.getResponseTimeTrend.values.map((i: any) => i.value)
			: [];
		state.getResponseTimeAverage = data.getResponseTimeAverage
			? data.getResponseTimeAverage.values.map((i: any) => i.value)
			: [];
		state.getSLATrend = data.getSLATrend
			? data.getSLATrend.values.map((i: any) => i.value)
			: [];
		state.getThroughputTrend = data.getThroughputTrend
			? data.getThroughputTrend.values.map((i: any) => i.value)
			: [];
		state.getLoadChildTrend.loadCountTotal = data.getLoadCalls
			? data.getLoadCalls.values.map((i: any) => i.value)
			: [];
		state.getLoadChildTrend.loadCountPerMin = data.getLoadCallsPerMin
			? data.getLoadCallsPerMin.values.map((i: any) => i.value)
			: [];

		state.getErrorTrend = data.getErrorTrend
			? data.getErrorTrend.values.map((i: any) => i.value)
			: [];
		state.getErrorChildTrend.errorCountPerMin = data.getErrorPerMin
			? data.getErrorPerMin.values.map((i: any) => i.value)
			: [];
		state.getErrorChildTrend.errorCountTotal = data.getErrorCalls
			? data.getErrorCalls.values.map((i: any) => i.value)
			: [];
		state.getErrorChildTrend.errorPercentage = state.getErrorChildTrend
			.errorCountTotal
			? [
					(state.getErrorChildTrend.errorCountTotal[0] /
						state.getLoadChildTrend.loadCountTotal[0]) *
						100
			  ]
			: [];

		if (!data.getPercentile) {
			state.responsePercentile = {};
			return;
		}
		data.getPercentile.forEach((item: any, index: number) => {
			state.responsePercentile[PercentileItem[index]] = item.values.map(
				(i: any) => i.value
			);
		});
	},
	setInstanceDependency(state: State, data: any) {
		state.instanceDependency = data;
	},
	setSelectedInstanceCall(state: State, data: Call) {
		state.selectedInstanceCall = data;
	},
	setInstanceDependenceMetrics(state: State, data: any) {
		state.instanceDependencyMetrics.getResponseTimeTrend = data.getResponseTimeTrend
			? data.getResponseTimeTrend.values.map((i: any) => i.value)
			: [];
		state.instanceDependencyMetrics.getSLATrend = data.getSLATrend
			? data.getSLATrend.values.map((i: any) => i.value)
			: [];
		state.instanceDependencyMetrics.getThroughputTrend = data.getThroughputTrend
			? data.getThroughputTrend.values.map((i: any) => i.value)
			: [];
		state.instanceDependencyMetrics.percentResponse = {};
		if (!data.getPercentile) {
			return;
		}
		data.getPercentile.forEach((item: any, index: number) => {
			state.instanceDependencyMetrics.percentResponse[
				PercentileItem[index]
			] = item.values.map((i: any) => i.value);
		});
	},
	setEndpointDependencyMetrics(state: State, data: { [key: string]: any }) {
		state.endpointDependencyMetrics.cpm = data.endpointRelationCpm
			? data.endpointRelationCpm.values.values.map((i: any) => i.value)
			: [];
		state.endpointDependencyMetrics.respTime = data.endpointRelationRespTime
			? data.endpointRelationRespTime.values.values.map((i: any) => i.value)
			: [];
		state.endpointDependencyMetrics.sla = data.endpointRelationSla
			? data.endpointRelationSla.values.values.map((i: any) => i.value)
			: [];
		state.endpointDependencyMetrics.percentile = {};
		if (!data.endpointRelationPercentile) {
			return;
		}
		for (const item of data.endpointRelationPercentile) {
			state.endpointDependencyMetrics.percentile[
				PercentileItem[Number(item.label)]
			] = item.values.values.map((i: any) => i.value);
		}
	},
	setInstanceDependenceType(state: State, data: string) {
		state.queryInstanceMetricsType = data;
	},
	setServiceDetail(state: State, data: any) {
		state.serviceApdexScore = data.serviceApdexScore
			? data.serviceApdexScore.values.map((i: any) =>
					Number((i.value / 10000).toFixed(2))
			  )
			: [];
		state.serviceApdexScoreAverage = data.serviceApdexScoreAverage
			? data.serviceApdexScoreAverage.values.map((i: any) =>
					Number((i.value / 10000).toFixed(2))
			  )
			: [];
		state.serviceResponseTime = data.serviceResponseTime
			? data.serviceResponseTime.values.map((i: any) => i.value)
			: [];
		state.serviceResponseTimeAvg = data.serviceResponseTimeAverage
			? data.serviceResponseTimeAverage.values.map((i: any) => i.value)
			: [];
		state.serviceErrorCount = data.serviceErrorCount
			? data.serviceErrorCount.values.map((i: any) => i.value)
			: [];
		state.serviceErrorCountChild.errorCountPerMin = data.serviceErrorPerMin
			? data.serviceErrorPerMin.values.map((i: any) => i.value)
			: [];
		state.serviceErrorCountChild.errorCountTotal = data.serviceErrorCountTotal
			? data.serviceErrorCountTotal.values.map((i: any) => i.value)
			: [];
		state.serviceErrorCountChild.errorPercentage = data.serviceErrorPercentage
			? data.serviceErrorPercentage.values.map((i: any) => i.value / 100)
			: [];
		state.serviceThroughput = data.serviceThroughput
			? data.serviceThroughput.values.map((i: any) => i.value)
			: [];
		state.serviceSLA = data.serviceSLA
			? data.serviceSLA.values.map((i: any) => i.value / 100)
			: [];
		if (!data.servicePercentile) {
			return;
		}
		data.servicePercentile.forEach((item: any, index: number) => {
			state.servicePercentile[PercentileItem[index]] = item.values.map(
				(i: any) => i.value
			);
		});
	},
	setTopoEndpoint(state: State, data: any[]) {
		state.topoEndpoints = data;
		window.localStorage.setItem('topologyEndpoints', JSON.stringify(data));
	},
	setTopoInstance(state: State, data: any[]) {
		state.topoInstances = data;
		window.localStorage.setItem('topologyInstances', JSON.stringify(data));
	},
	editTopoInstanceConfig(state: State, params: { values: any; index: number }) {
		state.topoInstances[params.index] = {
			...state.topoInstances[params.index],
			...params.values
		};
		window.localStorage.setItem(
			'topologyInstances',
			JSON.stringify(state.topoInstances)
		);
	},
	editTopoEndpointConfig(state: State, params: { values: any; index: number }) {
		state.topoEndpoints[params.index] = {
			...state.topoEndpoints[params.index],
			...params.values
		};
		window.localStorage.setItem(
			'topologyEndpoints',
			JSON.stringify(state.topoEndpoints)
		);
	},
	deleteTopoEndpoint(state: State, index: number) {
		state.topoEndpoints.splice(index, 1);
		window.localStorage.setItem(
			'topologyEndpoints',
			JSON.stringify(state.topoEndpoints)
		);
	},
	deleteTopoInstance(state: State, index: number) {
		state.topoInstances.splice(index, 1);
		window.localStorage.setItem(
			'topologyInstances',
			JSON.stringify(state.topoInstances)
		);
	},

	addTopoInstanceComp(state: State) {
		const comp = {
			width: 3,
			title: 'Title',
			height: 350,
			entityType: 'ServiceInstance',
			independentSelector: false,
			metricType: 'UNKNOWN'
		};
		state.topoInstances.push(comp);
		window.localStorage.setItem(
			'topologyInstances',
			JSON.stringify(state.topoInstances)
		);
	},

	addTopoEndpointComp(state: State) {
		const comp = {
			width: 3,
			title: 'Title',
			height: 350,
			entityType: 'Endpoint',
			independentSelector: false,
			metricType: 'UNKNOWN'
		};
		state.topoEndpoints.push(comp);
		window.localStorage.setItem(
			'topologyEndpoints',
			JSON.stringify(state.topoEndpoints)
		);
	},

	setEndpointDependency(state: State, data: { calls: Call[]; nodes: Node[] }) {
		state.endpointDependency = data;
	},

	setEndpointDepth(state: State, data: { key: number; label: string }) {
		state.currentEndpointDepth = data;
	},
	setTopoInfraRightState(state: State, val) {
		state.topoInfraRightState = val;
	},
	setTopoOverviewLeftState(state: State) {
		state.topoOverviewLeftState = !state.topoOverviewLeftState;
	},
	setTopoOverviewRightState(state: State) {
		state.topoOverviewRightState = !state.topoOverviewRightState;
	}
};

export default mutations;
